export type AddrDetailApiResponse =
  | /** status 200 Standard response */ ({
      placeId?: string | null;
      prefix?: string | null;
      street?: string | null;
      orientationNumber?: string | null;
      descriptiveNumber?: string | null;
      city?: string | null;
      zipCode?: string | null;
      postal?: string | null;
      district?: string | null;
      state?: string | null;
      country?: string | null;
      gps?: {
        lat?: string | null;
        lng?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ void;
export type AddrDetailApiArg = {
  placeId: string | null;
  language?: string | null;
};
export type AddrSuggestionsApiResponse = ({
  placeId?: string | null;
  formattedAddress?: string | null;
} | null)[];
export type AddrSuggestionsApiArg = {
  term: string | null;
  country: string | null;
  language?: string | null;
};
